var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg014Chat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.04983 21.87C3.25913 21.9564 3.48342 22.0005 3.70983 22C4.16095 22.0023 4.59378 21.8219 4.90983 21.5L7.40983 19H16.9998C19.7613 19 21.9998 16.7614 21.9998 14V8C21.9998 5.23858 19.7613 3 16.9998 3H6.99983C4.23841 3 1.99983 5.23858 1.99983 8V20.29C1.99334 20.982 2.40936 21.608 3.04983 21.87ZM3.99983 8C3.99983 6.34315 5.34298 5 6.99983 5H16.9998C18.6567 5 19.9998 6.34315 19.9998 8V14C19.9998 15.6569 18.6567 17 16.9998 17H6.99983C6.73403 16.9985 6.47855 17.1028 6.28983 17.29L3.99983 19.59V8ZM7.9999 12C8.55219 12 8.9999 11.5523 8.9999 11C8.9999 10.4477 8.55219 10 7.9999 10C7.44762 10 6.9999 10.4477 6.9999 11C6.9999 11.5523 7.44762 12 7.9999 12ZM11.9999 12C12.5522 12 12.9999 11.5523 12.9999 11C12.9999 10.4477 12.5522 10 11.9999 10C11.4476 10 10.9999 10.4477 10.9999 11C10.9999 11.5523 11.4476 12 11.9999 12ZM16.9999 11C16.9999 11.5523 16.5522 12 15.9999 12C15.4476 12 14.9999 11.5523 14.9999 11C14.9999 10.4477 15.4476 10 15.9999 10C16.5522 10 16.9999 10.4477 16.9999 11Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg014Chat);
export default __webpack_public_path__ + "static/media/014-chat.b976559ba17afe358b4dcb693e947899.svg";
export { ForwardRef as ReactComponent };